import { $_app_server } from '@/_helpers'

export const courtService = {
  courtRegister,
  getCourt,
  setCourtAlias,
  saveCourt,
  deleteCourt,

  getStamp,

  getCourtConfig,
  saveCourtConfig,
  tryDemo,
  testSmtp,
  resetSmtp
}

function courtRegister(obj) {
  return $_app_server.put("cabinet/register", obj)
  .then(response => response.data)
}

function getCourt() {
  return $_app_server.get("cabinet/init")
  .then(response => response.data)
}

function setCourtAlias () {
  if (localStorage.getItem("courtAlias") == null)
    $_app_server.get('/cabinet/alias').then(response => localStorage.setItem("courtAlias", response.data) )
}

function getStamp (court) {
  return $_app_server.post('/cabinet/court/stamp', court).then(response => response.data)
}

function saveCourt (obj) {
  return $_app_server.put('/cabinet/court/save', obj).then(response => response.data)
}

function deleteCourt () {
  return $_app_server.delete('/cabinet/court/del').then(response => response.data)
}

function getCourtConfig (obj) {
  return $_app_server.post('/cabinet/config', obj).then(response => response.data)
}

function saveCourtConfig (obj) {
  return $_app_server.put('/cabinet/config/save', obj).then(response => response.data)
}

function testSmtp() {
  return $_app_server.get("stmp/test")
  .then(response => response.data)
}

function resetSmtp() {
  return $_app_server.get("stmp/reset")
  .then(response => response.data)
}

function tryDemo(form) {
  return $_app_server.put("stmp/trydemo",form)
  .then(response => response.data)
}
